import { useCallback } from 'react';
const useInputChangeHandler = (onChange) => useCallback(async (e) => onChange(e.target.value), [onChange]);
export default useInputChangeHandler;
